import React from 'react';
import SoundtrailCard from './SoundtrailCard'
import { withFirebase } from '../Firebase'
import Grid from '@material-ui/core/Grid';
import { NewSoundtrailCard } from '../NewSoundtrail'

const SoundtrailList = () => (
    <SoundtrailListWithFirebase />
)

const INITIAL_STATE = { soundtrails: [], loading: true };


class SoundtrailListBase extends React.Component {

    constructor(props) {
        super(props);
        this.state = INITIAL_STATE;
    }

    getSoundtrailList(userData) {
        this.props.firebase.getSoundtrailList()
            .then((snapshot) => {
                let soundtrails = []
                for (let i = 0; i < snapshot.docs.length; i++) {
                    const data = snapshot.docs[i].data();
                    soundtrails.push(
                        <SoundtrailCard
                            id={snapshot.docs[i].id}
                            style={{ margin: "10px" }}
                            name={data.name}
                            image={data.tileImageUrl}
                            inApps={data.inApps}
                            code={data.code}
                            key={i}
                            open={"https://stxeditor.web.app/?stx=" 
                            + data.soundtrailKmlFileUrl 
                            + "&awsId=" + userData.awsId 
                            + "&awsKey=" + userData.awsKey
                            + "&audioBaseUrl=" + userData.audioBaseUrl
                            + "&imageBaseUrl=" + userData.imageBaseUrl
                            + "&copyright=" + userData.copyright
                            }
                            stxUrl={data.soundtrailKmlFileUrl}
                        />
                    );
                }
                soundtrails.push(<NewSoundtrailCard style={{ margin: "10px" }} key="new" onClose={() => this.setState({ loading: true })} />)
                this.setState({
                    soundtrails: soundtrails
                })
            });
    }

    render() {
        if (this.state.loading && this.props.firebase.auth.currentUser != null) {
            this.setState({ loading: false })
            this.props.firebase.getUserData().then((snapshot) => {
                let data = snapshot.data()
                this.getSoundtrailList(data)
            })
        }
        return (
            <Grid container spacing={10} xs={7} sm={7} md={8} lg={9}>
                {this.state.soundtrails}
            </Grid>
            // don't ask me what these mean (xs, sm, md, lg) but it seems to work.
        )
    }
}

const SoundtrailListWithFirebase = withFirebase(SoundtrailListBase);

export default SoundtrailList;